export enum LoadingState {
    LOADING = 'LOADING',
    NOTAVAILABLE = 'NOTAVAILABLE',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
}

export enum TrackingLabels {
    HOTEL_RECOMMENDERS = 'hotel_recommenders',
    BOTTOM = 'hotel_recommenders_offer_page',
    TOP = 'hotel_recommenders_offer_page_top',
}
